import { Link } from "react-router-dom";
import React from "react";

export default function SupportLinks() {
  return (
    <div className="flex flex-col items-start space-y-1">
      <span className="text-xl sm:text-2xl font-semibold mb-2">SUPPORT</span>
      <Link to="/contact-us" className="footer-links hover:underline text-sm sm:text-base">
        Contact
      </Link>
      <Link to="/experience-centres" className="footer-links hover:underline text-sm sm:text-base">
        Experience Centres
      </Link>
      <Link to="/grievance-regressal" className="footer-links hover:underline text-sm sm:text-base">
        Grievance Regressal
      </Link>
      <Link to="/terms-and-conditions" className="footer-links hover:underline text-sm sm:text-base">
        Terms & Conditions
      </Link>
      <Link to="/privacy-policy" className="footer-links hover:underline text-sm sm:text-base">
        Privacy Policy
      </Link>
    </div>
  );
}
